import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  idealFor: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK ITALIANO',
  description: '6 Tomos + 6 Bonos',
  idealFor: 'Todos los niveles A1→C2',
  originalPrice: '$51.000',
  price: '$19.990 ARS',
  ctaText: '→ QUIERO MI MEGAPACK',
  ctaHref: 'https://www.profepack.com/cart/48159375327488:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ADAPTACIONES ⭐',
  description: '6 Tomos + 6 Bonos + Kit Inclusión completo',
  idealFor: 'Grupos heterogéneos, NEE, niveles mixtos',
  originalPrice: '$69.000',
  price: '$27.990 ARS',
  ctaText: '→ QUIERO EL MEGAPACK + ADAPTACIONES',
  ctaHref: 'https://www.profepack.com/cart/48159407145216:1',
  isFeatured: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-233">
      <div className="max-w-xl mx-auto" data-id="element-234">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-235">
          ELEGÍ TU <span className="text-[#00C853]" data-id="element-236">MEGAPACK</span>
        </h2>

        {/* Options */}
        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8 mt-8" data-id="element-237">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#00C853] bg-[#000d08] shadow-[0_0_30px_rgba(0,200,83,0.15)]' : isFeatured ? 'border-2 border-[#00C853]/50 bg-[#000d08]' : isSelected ? 'border-2 border-[#00C853] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-238">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-239">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#00C853]' : 'border-white/30'}`} data-id="element-240">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#00C853]" data-id="element-241" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-242">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-243">
                      <span className="text-lg" data-id="element-244">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-245">
                        {option.title}
                      </span>
                    </div>

                    <p className="text-gray-400 text-sm mt-1" data-id="element-246">
                      {option.description}
                    </p>
                    <p className="text-[#00C853] text-xs font-bold mt-1" data-id="element-247">
                      Ideal para: {option.idealFor}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-248">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-249">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#00C853]' : 'text-white'}`} data-id="element-250">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#00C853] font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#00E676] transition-colors text-[#FFFFFF]" data-id="element-251">
          {selectedOption.ctaText}
        </a>
      </div>
    </section>;
}